import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../core/hooks/storeHooks';

interface SaveDiscardChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  disableManualMode?: boolean;
  saveChanges: (disableManualMode?: boolean) => void;
  discardChanges: (disableManualMode?: boolean) => void;
}
const SaveDiscardChangesDialog: React.FC<SaveDiscardChangesDialogProps> = ({
  isOpen,
  disableManualMode,
  onClose,
  saveChanges,
  discardChanges,
}) => {
  const contineuRef = useRef(null);
  const { t } = useTranslation();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={contineuRef}
      onClose={onClose}
      closeOnEsc={true}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {t('permission.changes.header')}
        </AlertDialogHeader>

        <AlertDialogCloseButton />

        <AlertDialogBody>{t('permission.changes.message')}</AlertDialogBody>

        <AlertDialogFooter>
          <Button
            colorScheme="red"
            onClick={() => {
              discardChanges(disableManualMode);
              onClose();
            }}
            mr={3}
          >
            {t('permission.changes.discard')}
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              saveChanges(disableManualMode);
              onClose();
            }}
            ref={contineuRef}
          >
            {t('permission.changes.save')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SaveDiscardChangesDialog;
